import apiClient from "./client";
import type { LicenseActivation, ApiResponse, ListResponse } from "@/types";

const BASE = "/activations";

export interface ActivationQueryParams {
  page?: number;
  page_size?: number;
  search?: string;
  logic?: "and" | "or";
  id?: number;
  type?: string;
  status?: string;
  issue_id?: number;
  client_id?: string;
  hostname?: string;
  host_ip?: string;
  project_id?: number;
  project_name?: string;
  product_name?: string;
  customer_id?: number;
  customer_name?: string;
  activated_at_start?: string;
  activated_at_end?: string;
  expires_at_start?: string;
  expires_at_end?: string;
}

export async function listActivations(
  params?: ActivationQueryParams,
): Promise<ApiResponse<ListResponse<LicenseActivation>>> {
  const { data } = await apiClient.get(BASE, { params });
  return data;
}

export async function getActivation(
  id: number,
): Promise<ApiResponse<LicenseActivation>> {
  const { data } = await apiClient.get(`${BASE}/${id}`);
  return data;
}

export async function deactivateActivation(
  id: number,
): Promise<ApiResponse<LicenseActivation>> {
  const { data } = await apiClient.post(`${BASE}/${id}/deactivate`);
  return data;
}

export async function batchDeactivateActivations(data: {
  ids: number[];
}): Promise<ApiResponse<unknown>> {
  const { data: _ } = await apiClient.post(`${BASE}/batch-deactivate`, data);
  return { data: _ } as ApiResponse<unknown>;
}
